import {RouteService} from "../../../../../services/routeService";
import {NotificationService} from "../../../../../services/notificationService";
import {GeneralService} from "../../../../../services/generalService";
import {DICTIONARY} from "../../../../../dictionary";
import {Component, OnInit, ViewChild} from "@angular/core";
import {Router} from "@angular/router";
import {TrustifiTableComponent} from "../../../../uiComponents/trustifi-table/trustifi-table.component";

@Component({
	selector: 'app-inbound-scan-metrics',
	templateUrl: './inbound-scan-metrics.component.html'
})
export class InboundScanMetricsComponent implements OnInit {
	constructor(private rs:RouteService,
				private ns:NotificationService,
				public gs:GeneralService,
				private router:Router) {
	}

	@ViewChild(TrustifiTableComponent) trustifiTable: TrustifiTableComponent;

	dic = DICTIONARY;
	filterData;
	loadingMetricsInProcess;
	scanMetrics;
	updateMetricInProcess;
	activeChipStatus: string = null;

	statusConfig: {[key: string]: {color: string, bg: string, icon: string}} = {
		'Malicious':  {color: '#b91c1c', bg: 'rgba(185,28,28,0.08)',  icon: 'far fa-exclamation-triangle'},
		'Suspicious': {color: '#c2410c', bg: 'rgba(194,65,12,0.08)',  icon: 'far fa-exclamation-circle'},
		'Spam':       {color: '#c58917', bg: 'rgba(146,64,14,0.08)',  icon: 'far fa-ban'},
		'Graymail':   {color: '#4b5563', bg: 'rgba(75,85,99,0.08)',   icon: 'far fa-inbox'},
	};

	ngOnInit() {
		this.getScanMetrics();
		this.initFilters();
	};

	getScanMetrics = () => {
		this.loadingMetricsInProcess = true;
		this.rs.getInboundScanMetrics().then((response) => {
			response.scan_metrics.forEach((metricObj) => {
				this.setCategoryColor(metricObj);
			});
			this.scanMetrics = response.scan_metrics;
			this.loadingMetricsInProcess = false;
		}, (err) => {
			this.loadingMetricsInProcess = false;
		});
	}

	initFilters = () => {
		this.filterData = {
			filterType: this.dic.CONSTANTS.tableFilters.inboundScanMetrics,
			filters: {
				category: ['Malicious', 'Suspicious', 'Spam', 'Graymail', 'External'],
			},
			initFiltersFunction: this.initFilters,
		};
	}

	setCategoryColor = (metricObj) => {
		switch (metricObj.status) {
			case this.dic.CONSTANTS.threatProtection.status.malicious:
				metricObj.color = 'darkred';
				break;

			case this.dic.CONSTANTS.threatProtection.status.suspicious:
				metricObj.color = 'darkred';
				break;


			case this.dic.CONSTANTS.threatProtection.status.spam:
				metricObj.color = 'darkorange';
				break;

			case this.dic.CONSTANTS.threatProtection.status.grayMail:
				metricObj.color = 'dimgray';
				break;

			case this.dic.CONSTANTS.threatProtection.status.unsecured:
				metricObj.color = 'darkorange';
				break;

			case this.dic.CONSTANTS.threatProtection.status.safe:
				metricObj.color = 'darkgreen';
				break;

			case 'External':
				metricObj.color = 'darkorange';
				break;
		}
	};

	clickChipFilter = (status: string) => {
		if (this.activeChipStatus === status) {
			// deselect — clear all filters
			this.activeChipStatus = null;
			this.trustifiTable.clearFilters();
		} else {
			this.activeChipStatus = status;
			this.trustifiTable.applyFilters({category: [status]});
		}
	}

	goToQuarantine = (metric) => {
		const data: any = {category: [metric.status]};
		if (metric.category) {
			data.sub_category = [metric.category];
		}
		this.router.navigate(
			[this.dic.CONSTANTS.appStates.adminInbound, this.dic.CONSTANTS.adminPages.inbound.quarantined],
			{state: {data}}
		);
	}

	updateScanMetric = (metric) => {
		this.updateMetricInProcess = true;
		this.rs.updateScanMetric(metric.key, {enabled: metric.enabled}).then(() => {
			this.updateMetricInProcess = false;
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
		}, () => {
			metric.enabled = !metric.enabled;
			this.updateMetricInProcess = false;
		});
	}

	searchMetrics = (event) => {
		// Keep chip visual state in sync when the table's own filter dropdown is used
		const cats = event.activeFilters?.category;
		if (cats?.length === 1 && this.statusConfig[cats[0]]) {
			this.activeChipStatus = cats[0];
		} else if (!cats?.length) {
			this.activeChipStatus = null;
		}

		this.scanMetrics.forEach(record => {
			// search
			if (event.searchTerm) {
				const isFound = searchTextExecute(record, event.searchTerm);
				if (!isFound) {
					record.hide = true;
					return;
				}
			}

			// filter
			if (event.activeFilters) {
				// need to match all filter types
				let numFilterToMatch = Object.keys(event.activeFilters).length;

				if (event.activeFilters['category']?.length) {
					if (event.activeFilters['category'].includes(record.status)) {
						numFilterToMatch--;
					}
				}

				if (numFilterToMatch) {
					record.hide = true;
					return;
				}
			}

			record.hide = false;
		});
	}
}

function searchTextExecute(record, searchTerm) {
	searchTerm = searchTerm.toLowerCase();

	return ((record.sub_status?.toLowerCase().indexOf(searchTerm) > -1) ||
		(record.status?.toLowerCase().indexOf(searchTerm) > -1) ||
		(record.description?.toLowerCase().indexOf(searchTerm) > -1));
}
